module.exports = __webpack_public_path__ + "img/SES_69000690.6b61ac99.jpg";